export default __webpack_public_path__ + "media/zurb/img/services/design-insight/design-insight-img1-85ea2f63585a9855fe45799fe3bb02bf.png";